/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { CardWrapper, BoxButton } from './styles';

// Modal de Ajuda
const HelpModal = ({ onClose }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef}>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Title secondary>
        Sobre os extratos
      </Title>
      <Text>
        Clique no assunto em que deseja obter mais informações:
      </Text>
      <a onClick={() => window.open('https://intercom.help/tikal-tech/pt-BR/articles/4848746-loit-fgts-obtencao-dos-extratos-do-fgts-junto-a-caixa')}>
        <Text>
          Onde conseguir os extratos do FGTS?
        </Text>
      </a>
      <a onClick={() => window.open('https://intercom.help/tikal-tech/pt-BR/articles/5072013-loit-fgts-nao-consigo-anexar-os-extratos-o-que-fazer')}>
        <Text>
          Não consegue anexar os extratos? Veja os erros mais comuns e como solucionar
        </Text>
      </a>
      <Title secondary>
        Sobre o cálculo
      </Title>
      <Text>
        O cálculo da LOIT FGTS é baseado nos lançamentos contidos em seu extrato do FGTS. Nele, substituímos a Taxa Referencial (TR) pelo Índice Nacional de Preços ao Consumidor Amplo (IPCA).
      </Text>
      <Title secondary>
        Sobre o Código ou Cupom
      </Title>
      <Text>
        Este campo NÃO é obrigatório. Preencha apenas caso você tenha conhecido a LOIT através de uma indicação que forneceu um código/cupom. Em alguns casos pode reverter em algum benefício na aquisição dos serviços.
      </Text>
      <BoxButton>
        <Button onClick={() => {
          window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace('/', '')}`);
          window.Intercom('show');
          onClose(false);
        }}
        >
          Iniciar conversa com o suporte
        </Button>
      </BoxButton>
    </CardWrapper>
  );
};

HelpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default HelpModal;
